import { useEffect, useState } from "react";
import Reset from "../Images/reset.png";
import WithoutLyrics from "../Images/audiolyrics.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";
import $ from "jquery";
import ListPagination from "../Components/ListPagination";
import "../Styles/Audios.css";
import "../Styles/Sidebar.css";
import { useTranslation } from "react-i18next";
import i18n from "../i18n";
import articalIcon from "../assets/img/article-icon.png";
import AuthorsService from "../Services/Authors";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ArticlesService from "../Services/Articles";
import { LogInModel } from "./LoginModel";
import Loader from "./Loader";
import { useVideo } from "../Contexts/VideosContext";
import VideoDialog from "./VideoDialog";
import { isIP } from "net";
import { FilterIcon, SortIcon } from "./Icon";

const ArticlesPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
 const [hoveredCategoryId, setHoveredCategoryId] = useState<any>(null);
const [hoveredAuthorId, setHoveredAuthorId] = useState<any>(null);
  const [refresh, setRefresh] = useState(false);
  const [SortValue, setSortValue] = useState("3");
  const [Category, setCategory] = useState<any>("");
  const [CategoryId, setCategoryId] = useState<any>("");
  const [Authors, setAuthors] = useState<any>("");
  const [AuthorsId, setAuthorsId] = useState<any>("");
  const [bread, showBread] = useState("");

  const [articles, setArticles] = useState<any[] | undefined>(undefined);
  const [pagination, setPagination] = useState({
    pageNo: 0,
    recordsPerPage: 12,
    totalRecords: 0,
  });

  const location = useLocation();
  const state = location.state as { authorId: string; authorName: string, authorSlug: string };

  // const [logIn, setLogIn] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);

  // const closeModal = () => {
  //   setLogIn(false);
  // };

  const [loginState, setLoginState] = useState<boolean>(false);

  // const handleLoginStateChange = (newState: any) => {
  //   setLoginState(newState === true);
  //   {
  //     articles?.map((article: any) => (
  //       navigate(`/articles/` + article?.slug, {
  //         state: {
  //           articleId: article?.id,
  //           articleName: article?.name,
  //           articleSlug: article?.slug,
  //           authorId: state?.authorId,
  //           authorName: state?.authorName,
  //           special: window?.location?.pathname,
  //         },
  //       })
  //     ))
  //   };
  // }

  function ResetData() {
    setCategoryId("");
    setAuthorsId("");
    setSortValue("3");
    setPagination({
      ...pagination,
      pageNo: 0,
    });
    setRefresh(true);
  }

  function ClickOnFilter(CategoryId: string, AuthorsId: string) {
    setRefresh(false);
    ArticlesService.getArticles(
      pagination.pageNo,
      pagination.recordsPerPage,
      false,
      CategoryId,
      AuthorsId || state?.authorId,
      "",
      SortValue,
      "",
      window.location.pathname === "/articles/special" ? true : false
    ).then((res) => {
      if (res) {
        setArticles(res.result?.items);
        setPagination({
          ...pagination,
          totalRecords: res.result?.totalRecords,
        });
      }
    });
  }

  // useEffect(() => {
  //   ClickOnFilter(CategoryId, AuthorsId);
  //   $(".CategoryList > ul > li > div").removeClass("listActive");
  //   $("#cat-" + CategoryId).addClass("listActive");

  //   $(".Authorlist > ul > li > div").removeClass("listActive");
  //   $("#aut-" + AuthorsId).addClass("listActive");
  // }, [CategoryId, AuthorsId]);

  useEffect(() => {
    ArticlesService.getFilters("article").then((res) => {
      if (res) {
        setCategory(res.result?.categories);
        setAuthors(res.result?.authors);
      }
    });
  }, [i18n.language]);

  useEffect(() => {
    setRefresh(false);
    const fetchData = async () => {
      try {
        const response = await ArticlesService.getArticles(
          pagination.pageNo === 0
            ? 0
            : pagination.recordsPerPage * pagination.pageNo - 12,
          pagination.recordsPerPage,
          false,
          CategoryId,
          AuthorsId || state?.authorId,
          "",
          SortValue,
          "",
          window.location.pathname === "/articles/special" ? true : false
        )
        const res = await response;
        setArticles(res.result?.items);
        setPagination({
          ...pagination,
          totalRecords: res.result?.totalRecords,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false); // Hide loader after fetching
      }
    }
    fetchData();
  }, [refresh, SortValue, i18n.language]);

  useEffect(() => {
    AuthorsService.GetAuthorDataById(state?.authorId).then((res) => {
      showBread(res?.result?.name);
    });
  }, [i18n.language, refresh]);

  const options = {
    height: "390",
    width: "100%",
    playerVars: {
      autoplay: 1,
      controls: 1,
      rel: 0,
      modestbranding: 1,
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

 const authorTitle =
  state?.authorName === "श्रद्धेय श्रीजयदयालजी गोयन्दका"
    ? t("Jayadayal_Ji_article_title")
    : state?.authorName === "श्रद्धेय श्रीहनुमानप्रसादजी पोद्दार"
    ? t("HanumanPrasad_Ji_article_title")
    : state?.authorName === "श्रद्धेय स्वामी श्रीरामसुखदासजी महाराज"
    ? t("Ramsukhdas_Ji_article_title")
    : t("Articles_title_tr");

const authorDescription =
  state?.authorName === "श्रद्धेय श्रीजयदयालजी गोयन्दका"
    ? t("Jayadayal_Ji_article_description")
    : state?.authorName === "श्रद्धेय श्रीहनुमानप्रसादजी पोद्दार"
    ? t("HanumanPrasad_Ji_article_description")
    : state?.authorName === "श्रद्धेय स्वामी श्रीरामसुखदासजी महाराज"
    ? t("Ramsukhdas_Ji_article_description")
    : t("Articles_description_tr");


  return (
    <>

<div style={{ backgroundColor: "rgb(255, 237, 188)", padding: "0px 0px 0px 0px",marginTop:"-60px" }}>
      <div style={{ width: "100%", maxWidth: "1200px", margin: "0 auto", padding: "0 10px",backgroundColor:"rgb(255, 237, 188)" }}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                gap: "20px",
                flexWrap: "wrap",
                padding: "28px 0 16px",
              }}
            >
              <div style={{ flex: "0 1 260px", minWidth: "220px" }}>
                <div style={{ padding: "8px 0" }}>
                  <h2 style={{ color: "#cf2c24", fontSize: "40px", margin: 0, fontWeight: 700,marginTop:"70px", textShadow: "0px 0px 4px rgba(255,255,255,0.9)" }}>
                    {t("Article_tr")}
                  </h2>
                  <div style={{ marginTop: "10px", fontSize: 19,fontWeight:600,color:"rgb(45, 42, 41)" }}>
                    <Link to="/" style={{ marginRight: "", color: "#2d2a29" }}>{t("Home_tr")}</Link>
                    <span style={{ margin: "0 6px" }}>/</span>
                    <span>{t("Article_tr")}</span>
                  </div>
                </div>
              </div>

              <div
                style={{
                  width: "1px",
                  minHeight: "100px",
                  background: "#facc6f",
                  marginTop: "65px",
                }}
              />

              <div style={{ flex: "1 1 520px", minWidth: "300px" }}>
                <h1
                  style={{
                    textAlign: "center",
                    color: "rgb(228, 121, 7)",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.9)",
                    fontWeight: 600,
                    margin: 0,
                    paddingTop:"30px",
                    // marginb:"-10px",
                    fontSize:"32px",
                  }}
                >
                  {/* {t("Articles_title_tr")}             */}

                  {authorTitle}
                </h1>

                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginTop: "8px",
                    gap: "10px",
                    flexWrap: "wrap",
                  }}
                >
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                  <svg
                    width="26"
                    height="18"
                    viewBox="0 0 26 18"
                    style={{ margin: "0 12px" }}
                  >
                    <rect x="1" y="7" width="2" height="4" rx="1" fill="#E5B15A" />
                    <rect x="5" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="9" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="13" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                    <rect x="17" y="1" width="2" height="16" rx="1" fill="#E5B15A" />
                    <rect x="21" y="4" width="2" height="10" rx="1" fill="#E5B15A" />
                  </svg>
                  <div style={{ width: "250px", height: "1px", background: "#E5B15A" }} />
                </div>

                <p
                  style={{
                    fontSize: 17,
                    color: "#4a4036",
                    textShadow: "0px 0px 4px rgba(255,255,255,0.8)",
                    // margin: "25px 0 -10px",
                    margin:"18px 0px 0px 0px",
                    width: "100%",
                    lineHeight: 1.75,
                    whiteSpace: "normal",
                    overflowWrap: "break-word",
                    textAlign: "center",
                  }}
                >
                  {/* {t("Articles_description_tr")} */}
                  {authorDescription}
                </p>
              </div>
            </div>
      </div>
  </div>



      <div
        className="fontfamily"
        style={{
          userSelect: "none",
          backgroundColor: "rgb(255, 246, 225)",
          padding: "1px 0 3% 0",
        }}
      >
        <div className="containers">
          <div
            className="gst-page-content pagecontentbackground"
            style={{ backgroundColor: "#FFF6E1" }}
          >
            <div className="row">
              <div className="col-lg-3">
                <div
                  style={{
                    display: "block",
                    padding: "16px",
                    borderRadius: "4px",
                    background: "#FFFAF0",
                    boxShadow: "0 0 7px 1px #f5deb1",
                    fontFamily: "ChanakyaUni",
                    height: "100%",
                  }}
                >
                  <div className="cardbackground" style={{ cursor: "pointer" }}>
                    <FilterIcon/>  <span className="boxheadtitle" style={{color:"rgb(228, 121, 7)"}} >{t("Filter_tr")}</span>
                    {(CategoryId !== "" || AuthorsId !== "" || pagination.pageNo > 1) && (
                      <img
                        alt="reset"
                        src={Reset}
                        className="resetimg"
                        onClick={() => {
                          ResetData();
                        }}
                      />
                    )}
                  </div>

                  <div style={{ backgroundColor: "#fffaec" }}>
                    <Accordion defaultExpanded elevation={0}>
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        style={{
                          height: 0,
                          background: "#FFFAF0",
                          minHeight: "25px"
                        }}
                      >
                        {/* <h2 className="filtertitle">{t("Article_List_tr")}</h2> */}
                         <p className="filtertitle" style={{fontSize:"20px",paddingTop:10}}>{t("Article_List_tr")}</p>
                      </AccordionSummary>

                      <AccordionDetails
                        style={{
                          display: "block",
                          background: "#FFFAF0",
                          // padding: "10px 0 0 0"
                        }}
                      >
                        {Category && Category.length > 0
                          ? Category?.map((Category: any) => (
                            <div
                              key={`c-${Category.id}`}
                              className="CategoryList"
                              onClick={() => {
                                setCategoryId(Category.id);
                                setAuthorsId("");
                              }}
                            >
                              <ul style={{ margin: 0 }}>
                                <li>
                                  <h2
                                    style={{
                                      fontSize: "21px",
                                      cursor: "pointer",
                                      fontWeight: 400,
                                      // color: "#545454",
                                          color:
                                      CategoryId === Category.id
                                        ? "red"
                                        : hoveredCategoryId === Category.id
                                        ? "#cf2c24"
                                        : "#545454",
                                       transition: "0.2s",
                                      
                                      fontFamily: "ChanakyaUni",
                                    }}
                                    id={`cat-${Category.id}`}
                                    onMouseEnter={() => setHoveredCategoryId(Category.id)}
                                    onMouseLeave={() => setHoveredCategoryId(null)}
                                  >
                                    {Category.name}
                                  </h2>
                                </li>
                              </ul>
                            </div>
                          ))
                          : ""}
                      </AccordionDetails>
                    </Accordion>
                    {/* writer  */}
                    <Accordion
                      elevation={0}
                      style={{ display: state?.authorId ? "none" : "block" }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMore />}
                        style={{
                          height: 0,
                          background: "#FFFAF0",
                          minHeight: "40px"
                        }}
                      >
                        {/* <h2 className="filtertitle">{t("Authors_tr")}</h2> */}
                         <p className="filtertitle" style={{fontSize:"20px",paddingTop:10}}>{t("Authors_tr")}</p>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          display: "block",
                          background: "#FFFAF0",
                          padding: "10px 0 0 0"
                        }}
                      >
                        {Authors && Authors.length > 0
                          ? Authors?.map((Author: any) => (
                            <div
                              key={`c-${Author.id}`}
                              className="Authorlist"
                              onClick={() => {
                                setAuthorsId(Author.id);
                                setCategoryId("");
                              }}
                            >
                              <ul style={{ margin: 0 }}>
                                <li>
                                  <h2
                                    style={{
                                      fontSize: "21px",
                                      cursor: "pointer",
                                      fontWeight: 400,
                                      // color: "#545454",
                                      fontFamily: "ChanakyaUni",
                                          color:
                                        AuthorsId === Author.id
                                          ? "red"
                                          : hoveredAuthorId === Author.id
                                          ? "#cf2c24"
                                          : "#545454",
                                        transition: "0.2s",
                                        }}
                                    id={`aut-${Author.id}`}
                                      onMouseEnter={() => setHoveredAuthorId(Author.id)}
                                      onMouseLeave={() => setHoveredAuthorId(null)}
                                  >
                                    {Author.name}
                                  </h2>
                                </li>
                              </ul>
                            </div>
                          ))
                          : ""}
                      </AccordionDetails>
                    </Accordion>
                  </div>
                </div>
              </div>
              <div className="col-lg-9">
                <div
                  className="detailbg"
                  style={{
                    display: "block",
                    padding: "16px",
                    borderRadius: "4px",
                    background: "rgb(255, 250, 240)",
                    boxShadow: "rgb(245, 222, 177) 0px 0px 7px 1px",
                    height: "100%",
                    fontFamily: "ChanakyaUni",
                  }}
                >
                  <div className="" >
                    <div className="row" >
                      <div className="filter1 col-6">
                        <span
                          style={{
                            fontFamily:"chanakyaUni",
                            // fontFamily: "ChanakyaUni,NalandaTim,Tunga",
                          
                            // fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 600,
                            // color: "#54422d",
                            // margin: "6px 15px 0 0",
                            marginLeft:"22px",
                            color:"rgb(228, 121, 7)",
                            fontSize:"22px"

                          }}
                        >
                          {t("Total_Records_tr")}
                           :  <span style={{color:"#54422d",fontFamily:"chanakyaUni",fontSize:"22px"}}>{pagination.totalRecords}</span>
                        </span>
                      </div>
                      <div
                        className="filter1 col-6"
                        style={{ textAlign: "right" ,marginTop:"-14px"}}
                      >
                       <SortIcon/> <span style={{color:"rgb(228, 121, 7)", fontSize:"22px",fontFamily:"chanakyaUni" }}>{t("Sort_tr")}</span>
                        <select
                          style={{ backgroundColor: "rgb(255, 242, 213)" }}
                          value={SortValue}
                          onChange={(e) => {
                            setSortValue(e.target.value);
                          }}
                        >
                          <option value="2">{t("Latest_tr")}</option>
                          <option value="0">{t("General_tr")}</option>
                          <option value="1">{t("Title_tr")}</option>
                          <option value="3">{t("Popular_tr")}</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {articles && articles.length > 0 ? (
                    <>
                      <div>
                        <div className="row">
                          {articles?.map((article) => (
                            <div
                              className="col-lg-4"
                              style={{ marginTop: "28px" }}
                              key={`art-${article?.id}`}
                            >
                              <div
                                style={{
                                  transition: "all .5s ease",
                                  textAlign: "center",
                                  backgroundColor: "#fff",
                                  borderRadius: "6px",
                                  padding: "20px 30px",
                                  boxShadow: "0 0 10px 0 #dcd1b8",
                                  height: "145px",
                                  margin: "6px 0 22px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                                onClick={() => {
                                  // if (UserIdentity) {
                                  if (window.location.pathname === `/articles`) {
                                    navigate(`/articles/` + article?.slug, {
                                      state: {
                                        articleId: article?.id,
                                        articleName: article?.name,
                                        articleSlug: article?.slug,
                                        authorId: state?.authorId,
                                        authorName: state?.authorName,
                                        special: window?.location?.pathname,
                                      },
                                    });
                                  }
                                  if (window.location.pathname === `/articles/special`) {
                                    navigate(`/articles/special/` + article?.slug, {
                                      state: {
                                        articleId: article?.id,
                                        articleName: article?.name,
                                        articleSlug: article?.slug,
                                        authorId: state?.authorId,
                                        authorName: state?.authorName,
                                        special: window?.location?.pathname,
                                      },
                                    });
                                  }
                                  if (window.location.pathname === `/articles/author/` + state?.authorSlug) {
                                    navigate(`/articles/author/` + state?.authorSlug + "/" + article?.slug, {
                                      state: {
                                        articleId: article?.id,
                                        articleName: article?.name,
                                        articleSlug: article?.slug,
                                        authorId: state?.authorId,
                                        authorName: state?.authorName,
                                        authorSlug: state?.authorSlug,
                                        special: window?.location?.pathname,
                                      },
                                    });
                                  }
                                  // }
                                  // else {
                                  //   setLogIn(true)
                                  // }
                                }}
                              >
                                <div>
                                  <a style={{ cursor: "pointer", }}>
                                    <img
                                      style={{
                                        width: "28px",
                                        height: "34px",

                                        borderRadius: 0,
                                      }}
                                      src={articalIcon}
                                      onError={(e) => {
                                        e.currentTarget.src = WithoutLyrics;
                                      }}
                                      alt={article.name}
                                      title={article.name}
                                      width="60"
                                    // onClick={() => { }}
                                    />
                                    <h3
                                      style={{
                                        color: "#3f220d",
                                        fontSize: "18px",
                                        lineHeight: "22px",
                                        margin: "20px 0 0",
                                        fontStyle: "normal",
                                        fontWeight: 600,
                                      }}
                                    >
                                      {article.name}
                                    </h3>
                                  </a>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="col-12" style={{ marginTop: "30px", display: pagination.totalRecords <= 12 ? "none" : "block" }}>
                        <ListPagination
                          totalRecords={pagination.totalRecords}
                          recordsPerPage={pagination.recordsPerPage}
                          onClick={(p) => {
                            setPagination({
                              ...pagination,
                              pageNo: p,
                            });
                            setRefresh(true);
                          }}
                        />
                      </div>
                    </>
                  ) : (
                    <div className="ebooks-category resultnotfound">
                      {loading && <Loader loading={loading} />}
                      {t("result_not_found_tr")}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <LogInModel
          opens={logIn}
          onCloses={closeModal}
          onLoginStateChange={handleLoginStateChange}
        /> */}
      </div>
    </>
  );
};
export default ArticlesPage;
